import Menu from 'components/Menu';
import RoundyContainer from 'components/RoundyContainer';
import DisclosureAgreement from 'components/StraightThroughVehicleComp/DisclosureAgreement/DisclosureAgreement';
import { ReplaceVehicleContext, ReplaceVehicleContextComp } from 'components/StraightThroughVehicleComp/ReplaceVehicleContext/ReplaceVehicleContext';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { storageData } from 'services/Services';
import VehicleProgressBreadCrumb from 'components/StraightThroughVehicleComp/VehicleProgressBreadCrumb';
import ReplaceVehicleMain from 'components/StraightThroughVehicleComp/VehicleMain_Replace/ReplaceVehicleMain';

const ReplaceVehicle = (props) => {
    const navigate = useNavigate()
    const { userData, setUserData } = props.user
    const [showModal, setShowModal] = useState(true);
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    const handleClose = () => {
        setShowModal(false);
        userData["disclosureModal"] = true
        storageData.setItem("userData", JSON.stringify(userData));
    }

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for Add Vehicle Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementReplaceVehicle")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <ReplaceVehicleContextComp>
                <Menu Title={"REPLACE VEHICLE"} FirstName={userData.firstName} userData={userData} />
                <VehicleProgressBreadCrumb requestContext={ReplaceVehicleContext} endorsementType={"ReplaceVehicle"} />
                <RoundyContainer Content={ReplaceVehicleMain} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData
                    }}
                />

                {!userData?.disclosureModal &&
                    <DisclosureAgreement
                        showModal={showModal}
                        handleClose={handleClose}
                        title="DISCLOSURE AGREEMENT"
                        policyState={userData.state}
                    />
                }
            </ReplaceVehicleContextComp>
        </>
    )
}

export default ReplaceVehicle